"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DATE_OF_BIRTH: 'dateOfBirth',
  MOBILE_NUMBR: 'mobileNumber',
  EMAIL: 'email',
  PASSWORD: 'password',
  NATIONALITY: 'nationality',
  ID_NUMBER: 'idNumber',
  ID_VERSION_NUMBER: 'idVersionNumber',
  IQAMA_ID: 'iqamaId',
  IQAMA_VERSION_NUMBER: 'iqamaVersionNumber',
  PASSPORT_ID: 'passportId',
  ADDRESS: 'address',
  LICENSE_NUMBER: 'licenseNumber',
  EXPIRY_DATE: 'expiryDate'
};